var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#ddd;}.cls-4{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 96.68,
    y1: 117.67,
    x2: 492.49,
    y2: 403.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7a500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1814db"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "secure") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.94,12.1S231.27,117.7,79.56,124v96.66c0,272.21,215.38,304,215.38,304s215.37-31.79,215.37-304V124C358.61,117.7,294.94,12.1,294.94,12.1Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.5,257.05H239.37a24.48,24.48,0,0,0-24.49,24.49v99.59a24.49,24.49,0,0,0,24.49,24.49H350.5A24.5,24.5,0,0,0,375,381.13V281.54A24.49,24.49,0,0,0,350.5,257.05ZM284.45,371.1l-29-29,10.81-10.81,16.17,16.17,39.51-55.89,12.48,8.83Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260,206.72a34.91,34.91,0,0,1,69.82,0v37.51h15.39V206.72a50.31,50.31,0,0,0-100.61,0v37.51H260Z",
    transform: "translate(-1.5 0.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 293.44,
    cy: 564.4,
    rx: 86.04,
    ry: 15.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 600,
    height: 600
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.429776efb7a9a688dd1a98e3341a91fe.svg";
export { ForwardRef as ReactComponent };